export default __webpack_public_path__ + "static/media/gallery-wip-paint_03.69066d7e.jpg";